<engage-page-header></engage-page-header>
<div class="bg" [ngClass]="bgClass">
  <div class="container pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <p>Upload identification document.</p>
        </div>
      </div>
      @if (isiFrameURLReady) {
        <div class="row">
          <div class="col">
            <iframe [src]="trustediFrameURL" height="510" width="100%"
            sandbox="allow-top-navigation allow-same-origin allow-scripts" allow="camera"></iframe>
          </div>
        </div>
      }
      <div class="row" style="margin-top: 45px;">
        <div class="col mb-5">
          <button mat-raised-button (click)="proceed()" [disabled]="isProceedDisabled" class="primary">{{btnText}}</button>
        </div>
      </div>
    </div>
  </div>
</div>